import { useEffect, useState } from 'react';
import additionalTranslations from './i18n-catalog.json';

export function resolveAppLanguage(languages = []) {
    const first = languages.find(value => typeof value === 'string' && value.trim());
    const code = first?.trim().toLowerCase().split(/[-_]/)[0];
    return code === 'ko' || code === 'ja' ? code : 'en';
}

export function readAppLanguage() {
    if (typeof navigator === 'undefined') return 'ko';
    const nativeLocale = typeof window !== 'undefined' && window.ReactNativeWebView
        ? window.__APP_RUNTIME_INFO?.locale
        : null;
    if (nativeLocale) return resolveAppLanguage([nativeLocale]);
    return resolveAppLanguage(navigator.languages?.length ? navigator.languages : [navigator.language]);
}

const translations = {
    '점': ['pt', 'ポイント'],
    '알': ['Egg', '卵'],
    '매월 1일 도착': ['Ready day 1', '毎月1日に到着'],
    '정': ['tablet', '錠'],
    '상관없음': ['Any time', 'いつでも'],
    '하루 {v0}번': ['Daily doses: {v0}', '1日{v0}回'],
    '약 정보를 수정하세요': ['Edit medication information', '薬の情報を修正してください'],
    '기타': ['Other', 'その他'],
    '다음 단계까지 {points}점 남았어요. 꾸준히 챙기면 {stage}로 자라요.': ['Next stage: {points} XP remaining. Keep taking your doses to grow into {stage}.', '次の段階まであと{points}ポイントです。服薬を続けると{stage}に成長します。'],
    '다음 단계까지 {points}점': ['Next stage: {points} XP remaining', '次の段階まであと{points}ポイント'],
    '{month}월의 이야기': ['Month {month} story', '{month}月の物語'],
    '{month}월의 약 이야기': ['Month {month} medication story', '{month}月の服薬の物語'],
    'Google로 로그인': ['Sign in with Google', 'Google でログイン'],
    'Google 로그인에 실패했어요. 다시 시도해주세요.': ['Google sign-in failed. Try again.', 'Google ログインに失敗しました。再試行してください。'],
    'Google 로그인을 사용하려면 새 개발 앱이 필요해요': ['Google sign-in requires a new development build.', 'Google ログインには新しい開発ビルドが必要です。'],
    '로그인이 진행 중이에요': ['Sign-in is in progress.', 'ログイン処理中です。'],
    '슬라이드': ['Slide', 'スライド'],
    '다음': ['Next', '次へ'],
    '취소': ['Cancel', 'キャンセル'],
    '알림 허용하고 계속하기': ['Allow notifications and continue', '通知を許可して続ける'],
    '약 등록하러 가기': ['Add a medication', '薬を登録する'],
    '다음으로': ['Continue', '次へ'],
    '등록하기': ['Add medication', '薬を登録'],
    '처방전/약봉투로 한 번에 입력하기': ['Add from a prescription or medication bag', '処方箋・薬袋からまとめて登録'],
    '복용 기간을 선택해주세요': ['Choose a treatment period', '服薬期間を選んでください'],
    '알림 시간을 선택해주세요': ['Choose a reminder time', '通知時刻を選んでください'],
    '다음 약 설정': ['Set up the next medication', '次の薬を設定'],
    '이 약의 기간을 설정해주세요': ['Set a period for this medication', 'この薬の期間を設定してください'],
    '이 약의 알림을 설정해주세요': ['Set a reminder for this medication', 'この薬の通知を設定してください'],
    '얼마나 약을 복용하시나요?': ['How long will you take it?', 'いつまで服薬しますか？'],
    '계속 복용해요': ['Keep taking it', '継続して服薬する'],
    '종료일을 정하지 않아요.': ['No end date', '終了日は設定しません。'],
    '기간을 정해서 복용해요': ['Set a treatment period', '期間を決めて服薬する'],
    '며칠 동안 복용할지 정해요.': ['Choose how many days to take it.', '服薬する日数を決めます。'],
    '약마다 다른 기간': ['Different period for each medication', '薬ごとに異なる期間'],
    '모든 약 같은 기간': ['Same period for all medications', 'すべての薬で同じ期間'],
    '시작일': ['Start date', '開始日'],
    '종료일': ['End date', '終了日'],
    '없음': ['None', 'なし'],
    '등록한 약 확인하기': ['Review medications', '登録した薬を確認'],
    '언제 알려드릴까요?': ['When should we remind you?', 'いつお知らせしますか？'],
    '하루 몇 번 받을지 정해주세요.': ['Choose how many reminders to get each day.', '1日に何回通知するか選んでください。'],
    '하루에 몇 번 알려드릴까요?': ['How many times a day?', '1日に何回お知らせしますか？'],
    '{count}번': ['{count} times', '{count}回'],
    '시간 추가': ['Add time', '時刻を追加'],
    '다른 약 시간으로 맞추기': ['Use a time from another medication', 'ほかの薬の時刻に合わせる'],
    '선택': ['Optional', '任意'],
    '{name} 외 {count}개': ['{name} and {count} more', '{name}ほか{count}件'],
    '하루에 몇 번': ['Times per day', '1日の回数'],
    '이미 같은 시간이 있어요': ['This time is already added', '同じ時刻がすでにあります'],
    '하루 {count}번까지만 설정할 수 있어요': ['You can add up to {count} times per day', '1日に設定できる時刻は最大{count}回です'],
    '비어있는 시간을 먼저 선택해주세요': ['Choose the empty time first', '空欄の時刻を先に選んでください'],
    '알림 방식': ['Alert type', '通知方法'],
    '집요한 알림': ['Repeat reminders', '繰り返し通知'],
    '알림': ['Notification', '通知'],
    '일반 푸시 알림': ['Standard alert', '通常のプッシュ通知'],
    '진동 알림': ['Vibration', 'バイブ通知'],
    '계속 진동해요': ['Keeps vibrating', '振動を繰り返します'],
    '벨소리 알람': ['Sound alarm', 'アラーム音'],
    '무음에서도 울려요': ['May sound in silent mode', 'マナーモードでも鳴ります'],
    '켜짐': ['On', 'オン'],
    '꺼짐': ['Off', 'オフ'],
    '먹었다고 확인할 때까지 다시 알려드려요.': ['Reminds you again until you record the dose.', '服薬を記録するまで繰り返しお知らせします。'],
    '첫 알림 한 번만 보내요.': ['Sends one reminder only.', '最初の通知を1回だけ送ります。'],
    '알림 간격': ['Repeat interval', '通知間隔'],
    '변경': ['Change', '変更'],
    '{interval}분마다, 최대 {duration}': ['Every {interval} min, for up to {duration}', '{interval}分ごと、最大{duration}'],
    '{count}시간 동안': ['{count} hr', '{count}時間'],
    '{count}분 동안': ['{count} min', '{count}分'],
    '약 {count}개를 등록할게요': ['Review {count} medications', '薬{count}件を登録します'],
    '약 {count}': ['Medication {count}', '薬{count}'],
    '정해진 시간 없음': ['No fixed time', '決まった時刻なし'],
    '필요할 때만': ['As needed', '必要なときだけ'],
    '매일': ['Every day', '毎日'],
    '{date}까지': ['Until {date}', '{date}まで'],
    '{count}일 동안': ['For {count} days', '{count}日間'],
    '사진': ['Photo', '写真'],
    '기간': ['Period', '期間'],
    '접기': ['Collapse', '閉じる'],
    '자세히 보고 수정하기': ['Review and edit details', '詳細を確認・編集'],
    '어떤 약을 드시나요?': ['What medications do you take?', 'どのお薬を使っていますか？'],
    '복용할 약을 모두 입력해주세요.': ['Enter all your medications.', '使っているお薬をすべて入力してください。'],
    '약 이름을 입력해주세요': ['Enter a medication name', '薬の名前を入力してください'],
    '약 목록에서 찾는 중이에요': ['Searching medications', '薬を検索しています'],
    '식약처': ['Korean medicine database', '韓国の医薬品データベース'],
    '건기식': ['Supplement', '健康食品'],
    '등록 이름': ['User-submitted name', 'ユーザー登録名'],
    '원래 이름: {name}': ['Original name: {name}', '元の名前: {name}'],
    '한국 의약품 자료예요. 번역명은 해외 판매 제품을 뜻하지 않아요.': ['These are Korean medicine records. Translated names do not identify products sold abroad.', '韓国の医薬品データです。翻訳名は海外で販売される製品名ではありません。'],
    '원하는 약이 없나요?': ['Can’t find your medication?', 'お探しの薬がありませんか？'],
    '이 이름으로 추가할 수 있어요.': ['You can add it using this name.', 'この名前で追加できます。'],
    '검색 결과가 없어요': ['No results found', '検索結果がありません'],
    '이름 그대로 추가할 수 있어요.': ['You can add it using the name you entered.', '入力した名前のまま追加できます。'],
    '복용 정보는 직접 확인하고 입력해주세요.': ['Check and enter the directions yourself.', '服薬情報を確認して入力してください。'],
    '이 이름으로 추가하기': ['Add with this name', 'この名前で追加'],
    '오늘의 약': ['Today’s meds', '今日の薬'],
    '홈': ['Home', 'ホーム'],
    '약 목록': ['Medications', '薬一覧'],
    '{count}개의 약을 관리하고 있어요': ['Medications managed: {count}', '{count}種類の薬を管理中'],
    '아래 + 버튼으로 약을 등록해보세요': ['Tap + below to add a medication', '下の＋から薬を登録してください'],
    '격일': ['Every other day', '隔日'],
    '특정 요일': ['Selected days', '指定した曜日'],
    '몇 시간마다': ['Every few hours', '数時間ごと'],
    '며칠마다': ['Every few days', '数日ごと'],
    '먹고 쉬고 반복': ['Treatment cycle', '服薬と休薬を繰り返す'],
    '매월 특정일': ['Selected days each month', '毎月指定した日'],
    '아침': ['Morning', '朝'],
    '점심': ['Midday', '昼'],
    '저녁': ['Evening', '夕方'],
    '취침 전': ['Bedtime', '就寝前'],
    '{date}까지 복용': ['Until {date}', '{date}まで服薬'],
    '{date}부터 복용': ['Starts {date}', '{date}から服薬'],
    '복용 중지': ['Paused', '服薬停止中'],
    '지금 복용 중인 약이 없어요': ['No current medications', '現在服薬中の薬はありません'],
    '복용을 마친 약은 아래에서 확인할 수 있어요': ['See completed medications below', '服薬を終えた薬は下で確認できます'],
    '정해진 시간에 먹는 약': ['Scheduled medications', '定時に服薬する薬'],
    '복용 중지한 약': ['Paused medications', '服薬を停止した薬'],
    '복용 완료한 약': ['Completed medications', '服薬を終えた薬'],
    '{count}개 더 보기': ['Show {count} more', 'さらに{count}件表示'],
    '{remaining}/{total} doses': ['{remaining}/{total} doses', '残り{remaining}/{total}回分'],
    '사진을 불러오지 못했어요': ['Couldn’t load the photo', '写真を読み込めませんでした'],
    '수정하기': ['Edit', '編集'],
    '삭제': ['Delete', '削除'],
    '삭제 완료': ['Medication deleted', '薬を削除しました'],
    '삭제 실패': ['Couldn’t delete the medication', '薬を削除できませんでした'],
    '복용을 재개했어요': ['Reminders resumed', '服薬を再開しました'],
    '복용을 중지했어요': ['Reminders paused', '服薬を停止しました'],
    '오류 발생': ['Something went wrong', 'エラーが発生しました'],
    '전체 복용 중지는 설정에서 해제해주세요': ['Resume all reminders in Settings first', '設定で全体の服薬停止を解除してください'],
    '전체 복용 중지 중': ['All reminders paused', 'すべての服薬を停止中'],
    '복용 재개하기': ['Resume reminders', '服薬を再開'],
    '복용 중지하기': ['Pause reminders', '服薬を停止'],
    "'{name}' 약을 삭제할까요?": ['Delete {name}?', '{name}を削除しますか？'],
    '더 이상 알림이 오지 않아요. 이미 복용한 기록은 유지돼요.': ['Reminders will stop. Your dose history will stay.', '通知は停止します。これまでの服薬記録は残ります。'],
    '삭제할게요': ['Delete', '削除する'],
    '캘린더': ['Calendar', 'カレンダー'],
    '통계': ['Stats', '統計'],
    '설정': ['Settings', '設定'],
    '백업 및 동기화': ['Backup and sync', 'バックアップと同期'],
    '기기 {count}대에서 동기화 중': ['Syncing across {count} devices', '{count}台の端末で同期中'],
    '약 정보 백업 중': ['Medication data backed up', '薬の情報をバックアップ中'],
    '로그인하면 새 폰에서도 약 정보를 불러와요': ['Sign in to restore your medications on a new phone', 'ログインすると新しい端末でも薬の情報を復元できます'],
    '모든 약 알림 바꾸기': ['Change all medication alerts', 'すべての薬の通知を変更'],
    '푸시, 진동, 벨소리 알람을 한 번에 설정해요': ['Set push, vibration, and ringtone alerts together', 'プッシュ・振動・着信音をまとめて設定'],
    '푸시, 벨소리 알람을 한 번에 설정해요': ['Set push and ringtone alerts together', 'プッシュ・着信音をまとめて設定'],
    '알림 설정 불러오는 중': ['Loading alert settings', '通知設定を読み込み中'],
    '알림 설정을 불러오지 못했어요': ['Couldn’t load alert settings', '通知設定を読み込めませんでした'],
    '복용을 다시 시작했어요': ['Reminders resumed', '服薬通知を再開しました'],
    '저장 실패': ['Couldn’t save', '保存できませんでした'],
    '복용 알림 설정을 확인해주세요': ['Check your reminder settings', '服薬通知の設定を確認してください'],
    '불러오지 못했어요. 눌러서 다시 확인해요': ['Couldn’t load. Tap to try again', '読み込めませんでした。タップして再試行'],
    '직접 다시 시작할 때까지 알림을 쉬어요': ['Paused until you resume them', '再開するまで通知を停止します'],
    '{date}까지 알림을 쉬어요': ['Alerts paused through {date}', '{date}まで通知を停止します'],
    '날짜를 정해주세요': ['Choose a date', '日付を選んでください'],
    '모든 약의 복용 알림을 잠시 멈춰요': ['Temporarily pause all medication alerts', 'すべての薬の通知を一時停止'],
    '모든 광고 제거': ['Remove all ads', 'すべての広告を削除'],
    '모든 광고 제거 사용 중': ['Ad-free is active', '広告なしで利用中'],
    '휴대폰을 바꿔도 광고 제거가 유지돼요': ['Restore ad-free access on a new phone', '新しい端末でも広告なしで利用できます'],
    '내 데이터 모두 삭제': ['Delete all my data', '自分のデータをすべて削除'],
    '약 정보와 복용 기록을 영구 삭제해요': ['Permanently delete medications and dose history', '薬の情報と服薬記録を完全に削除します'],
    '개인정보 처리방침': ['Privacy policy', 'プライバシーポリシー'],
    '내 데이터를 모두 삭제할까요?': ['Delete all my data?', '自分のデータをすべて削除しますか？'],
    '등록한 약, 복용 기록, 보호자 연결, 신고 내역까지 모두 사라져요. 같은 그룹에 연결된 다른 기기의 데이터도 함께 삭제됩니다.': ['This deletes your medications, dose history, caregiver links, and reports. Data on other devices in the same group will also be deleted.', '登録した薬、服薬記録、見守りの連携、報告履歴がすべて削除されます。同じグループのほかの端末のデータも削除されます。'],
    '되돌릴 수 없어요': ['This cannot be undone', '元に戻せません'],
    '한 번 더 확인할게요. 정말로 모든 데이터를 영구 삭제할까요?': ['Please confirm: permanently delete all data?', '最終確認です。すべてのデータを完全に削除しますか？'],
    '삭제 중...': ['Deleting...', '削除中...'],
    '계정을 탈퇴할까요?': ['Delete your account?', 'アカウントを削除しますか？'],
    '계정의 약 정보·복용 기록·보관 기록과 가족 연결이 삭제되고, 연결된 모든 기기에서 로그아웃돼요.': ['Your medications, dose and archive history, and family links will be deleted. All connected devices will be signed out.', '薬の情報、服薬・保管記録、家族との連携が削除され、連携中のすべての端末からログアウトします。'],
    '삭제한 기록은 되돌릴 수 없어요.': ['Deleted records cannot be restored.', '削除した記録は元に戻せません。'],
    '다른 가족의 기록과 로그아웃 후 따로 저장한 기록은 남아요.': ['Other family members’ records and records saved separately after signing out will remain.', 'ほかの家族の記録と、ログアウト後に別途保存した記録は残ります。'],
    '스토어 구매는 자동 환불되지 않아요. 구매한 스토어 계정으로 광고 제거를 다시 복원할 수 있어요.': ['Store purchases are not automatically refunded. You can restore ad-free access with the store account used for purchase.', 'ストアでの購入は自動返金されません。購入したストアアカウントで広告なしの利用を復元できます。'],
    '현재 로그인된 계정으로 본인 확인 후 탈퇴해요.': ['Verify your identity with the current account before deletion.', '現在ログイン中のアカウントで本人確認してから削除します。'],
    '아니요': ['No', 'いいえ'],
    '확인 후 탈퇴': ['Verify and delete', '確認して削除'],
    '완료·중지·필요시 약은 제외돼요': ['Completed, paused, and as-needed medications are excluded', '終了・停止・必要時の薬は対象外です'],
    '변경할 알림 대상 약이 없어요': ['No scheduled medications to update', '変更する通知対象の薬がありません'],
    '알림 대상 약에 적용하기': ['Apply to scheduled medications', '通知対象の薬に適用'],
    '알림 대상 약 {count}개에 적용하기': ['Apply to {count} scheduled medications', '通知対象の薬{count}件に適用'],
    '복용을 다시 시작할까요?': ['Resume medication reminders?', '服薬通知を再開しますか？'],
    '전체 알림 중지를 해제하고': ['Resume all reminders', 'すべての通知停止を解除し'],
    '정해진 시간에 다시 알려드려요': ['We’ll remind you at the scheduled times', '設定した時刻に再びお知らせします'],
    '복용을 중지할까요?': ['Pause medication reminders?', '服薬通知を停止しますか？'],
    '모든 약의 복용 알림을 잠시 쉬어요': ['Pause reminders for all medications', 'すべての薬の通知を一時停止します'],
    '약 정보와 기록은 그대로 남아요': ['Your medications and dose history stay saved', '薬の情報と服薬記録は残ります'],
    '이 날짜까지': ['Until this date', 'この日まで'],
    '무기한 중지': ['Pause indefinitely', '期限を決めずに停止'],
    '직접 다시 시작할 때까지': ['Until I resume them', '手動で再開するまで'],
    '날짜를 선택해 주세요': ['Choose a date', '日付を選んでください'],
    '설정에서 언제든 다시 시작할 수 있어요.': ['You can resume reminders here anytime.', '設定からいつでも再開できます。'],
    '선택한 날의 다음 날부터 다시 알려드려요.': ['Reminders resume the day after the selected date.', '選択した日の翌日から通知を再開します。'],
    '등록된 약이 없어요': ['No medications added yet', '登録した薬はありません'],
    '오늘은 복용할 약이 없어요': ['No medications scheduled today', '今日飲む薬はありません'],
    '전체 복용 중지 중이에요': ['All reminders are paused', 'すべての服薬を一時停止中です'],
    '다음 일정까지 편히 쉬세요': ['You’re all set until your next dose', '次の予定までゆっくりお過ごしください'],
    '약을 등록하면 정한 시간에 알려드려요': ['Add a medication to get reminders', '薬を登録すると時間にお知らせします'],
    '약 등록하기': ['Add medication', '薬を登録'],
    '다음 복용:': ['Next dose:', '次の服薬:'],
    '먹었어요': ['Taken', '飲みました'],
    '사용했어요': ['Used', '使用しました'],
    '먹은 후에 눌러주세요': ['Tap after taking it', '飲んだ後に押してください'],
    '사용한 후에 눌러주세요': ['Tap after using it', '使用した後に押してください'],
    '나중에 먹을게요': ['Remind later', 'あとで飲みます'],
    '나중에 할게요': ['Remind later', 'あとで使用します'],
    '복용 완료': ['Dose recorded', '服薬完了'],
    '사용 완료': ['Use recorded', '使用完了'],
    '복용했어요': ['I took it', '飲みました'],
    '모두 완료': ['All done', 'すべて完了'],
    '완료': ['Done', '完了'],
    '건너뛰기': ['Skip', 'スキップ'],
    '건너뛰었어요': ['Skipped', 'スキップしました'],
    '미복용': ['Not taken', '未服薬'],
    '건너뜀': ['Skipped', 'スキップ'],
    '복용으로 변경': ['Mark as taken', '服薬済みに変更'],
    '되돌리기': ['Undo', '元に戻す'],
    '시간 미기록': ['Time not recorded', '時刻未記録'],
    '복용 기록': ['Dose history', '服薬記録'],
    '복용 예정': ['Scheduled doses', '服薬予定'],
    '이 날의 복용 기록이 없어요': ['No dose records for this day', 'この日の服薬記録はありません'],
    '이 날 복용할 약이 없어요': ['No medications scheduled for this day', 'この日に飲む薬はありません'],
    '오늘': ['Today', '今日'],
    '내일': ['Tomorrow', '明日'],
    '{count}일 뒤': ['In {count} days', '{count}日後'],
    '일': ['Sun', '日'], '월': ['Mon', '月'], '화': ['Tue', '火'], '수': ['Wed', '水'],
    '목': ['Thu', '木'], '금': ['Fri', '金'], '토': ['Sat', '土'],
    '알림 미룸': ['Reminder postponed', '通知を延期'],
    '미룬 시간 변경': ['Change reminder time', '延期時刻を変更'],
    '약을 눌러 따로 처리할 수도 있어요': ['Tap a medication to handle it separately', '薬をタップすると個別に記録できます'],
    '오늘 혹시 드셨나요?': ['Did you take these today?', '今日、薬を飲みましたか？'],
    '이 날 혹시 드셨나요?': ['Did you take these?', 'この日に薬を飲みましたか？'],
    '복용 시각이 이미 지난 약이에요': ['The scheduled time has passed', '服薬予定時刻を過ぎた薬です'],
    '등록 전이라 기록이 없어요. 드셨다면 남겨주세요': ['No record yet. Add one if you took it.', '登録前の記録はありません。飲んだ場合は記録してください'],
    '최신 내용을 불러오지 못했어요': ['Couldn’t refresh the latest information', '最新情報を読み込めませんでした'],
    '이전 내용을 계속 볼 수 있어요.': ['You can still view the previous information.', '前回の情報を引き続き確認できます。'],
    '다시 시도': ['Try again', '再試行'],
    '재고를 채워주세요': ['Refill your medications', '薬を補充してください'],
    '재고를 확인해주세요': ['Check your medication stock', '薬の残量を確認してください'],
    '건의함': ['Feedback', 'ご意見'],
    '답변이 도착했어요': ['You have a reply', '返信が届きました'],
    '의견 보내기': ['Send feedback', '意見を送る'],
    '가족 약 챙기기': ['Family care', '家族の薬を見守る'],
    '챙기는 중': ['Connected', '見守り中'],
    '시작하기': ['Get started', '始める'],
    'AI 상담': ['Ask AI', 'AIに相談'],
    '약 궁금증 물어보기': ['Ask about medications', '薬について質問'],
    '필요할 때 먹는 약': ['As-needed medications', '必要なときに飲む薬'],
    '추가하기': ['Add', '追加'],
    '재고 관리': ['Stock', '残量管理'],
    '증상 기록': ['Symptoms', '症状の記録'],
    '증상 남기기': ['Record symptoms', '症状を記録'],
    '가족': ['Family', '家族'],
    '가족 현황 공유가 중단됐어요': ['Family sharing is paused', '家族への共有を停止中です'],
    '나를 돌보는 가족 보기': ['View your caregivers', '見守っている家族を見る'],
    '광고 없이 편하게 사용해요': ['Use the app without ads', '広告なしで快適に使えます'],
    '약 챙기는 일에만 집중해요': ['Focus on your medications', '薬の管理に集中できます'],
    '첫 약을 등록해 보세요': ['Add your first medication', '最初の薬を登録しましょう'],
    '먹을 시간부터 다시 알림까지 챙겨요': ['Set a time and follow-up reminders', '服薬時刻と再通知を設定できます'],
    '{nickname}님이 약을 안 드셨어요': ['{nickname} hasn’t taken their medication', '{nickname}さんはまだ薬を飲んでいません'],
    '외 {count}명도 확인해주세요': ['Check {count} others too', 'ほかの{count}人も確認してください'],
    '지금 확인해주세요': ['Check now', '今すぐ確認'],
    '필요할 때 먹는 약도 기록해요': ['Track as-needed medications', '必要なときに飲む薬も記録'],
    '진통제·소화제, 언제 먹었는지 확인해요': ['See when you last took them', '最後に飲んだ時刻を確認できます'],
    '약 궁금증, AI에게 물어보세요': ['Ask AI about your medications', '薬についてAIに質問'],
    '이 약과 안 맞는 음식이 뭘까요?': ['Questions about your medications?', '薬について気になることはありますか？'],
    '약이 떨어지기 전에 알려드려요': ['Get a reminder before you run out', '薬がなくなる前にお知らせ'],
    '약국 갈 타이밍 놓치지 마세요': ['Know when it’s time to refill', '補充のタイミングを逃しません'],
    '증상 기록해두기': ['Record symptoms', '症状を記録'],
    '두통, 속쓰림 같은 변화를 남겨요': ['Track changes such as headaches', '頭痛などの変化を記録'],
    '건의 답변이 도착했어요': ['Your feedback has a reply', 'ご意見への返信が届きました'],
    '앱에 필요한 기능이 있나요?': ['Have an idea for the app?', 'アプリへのご意見はありますか？'],
    '개발자 답변을 확인해보세요': ['Read the developer’s reply', '開発者からの返信を見る'],
    '웬만하면 반영돼요': ['Tell us what would help', '必要な機能を教えてください'],
    '가족 약 챙기는 중': ['Caring for family', '家族を見守り中'],
    '오늘 누가 약을 잘 챙겼는지 보기': ['See today’s medication status', '今日の服薬状況を見る'],
    '엄마 아빠 약, 같이 챙겨요': ['Help your family stay on track', '家族の服薬を一緒に見守りましょう'],
    '안 드시면 알림으로 알려드려요': ['Get notified when a dose is missed', '飲み忘れたら通知します'],
    '기능 안내 불러오는 중': ['Loading tips', '機能案内を読み込み中'],
    '도움이 되는 기능 안내': ['Helpful features', '便利な機能'],
    '캐러셀': ['carousel', 'カルーセル'],
    '이전 안내': ['Previous tip', '前の案内'],
    '다음 안내': ['Next tip', '次の案内'],
    '다 떨어졌어요': ['Out of stock', '残りがありません'],
    '마지막 1정 남았어요': ['1 dose left', '残り1錠です'],
    '{count}정 남았어요': ['{count} doses left', '残り{count}錠です'],
    '{count}개 약이 다 떨어졌어요': ['{count} medications are out of stock', '{count}種類の薬がなくなりました'],
    '{count}개 약이 곧 떨어져요': ['{count} medications are running low', '{count}種類の薬が残りわずかです'],
    '{count}개 관리 중': ['Tracking {count} medications', '{count}種類を管理中'],
    '재고 알림 받기': ['Get refill reminders', '残量通知を受け取る'],
    '외 {count}개': ['and {count} more', 'ほか{count}種類'],
    '아직 안 먹음': ['Not taken yet', 'まだ飲んでいません'],
    '아직 안 씀': ['Not used yet', 'まだ使用していません'],
    '방금 전': ['Just now', 'たった今'],
    '{count}분 전': ['{count} min ago', '{count}分前'],
    '오늘 {time}': ['Today at {time}', '今日 {time}'],
    '어제': ['Yesterday', '昨日'],
    '{count}일 전': ['{count} days ago', '{count}日前'],
    '{count}달 전': ['{count} months ago', '{count}か月前'],
    '{count}년 전': ['{count} years ago', '{count}年前'],
    '{count}개 · 약을 눌러 기록하기': ['{count} · Tap to record', '{count}種類 · タップして記録'],
    '비상약 추가': ['Add as-needed medication', '必要時の薬を追加'],
    '추가': ['Add', '追加'],
    '오늘 챙김': ['Recorded today', '今日の記録'],
    '{time} 챙김': ['Recorded at {time}', '{time}に記録'],
    '시간 수정': ['Edit time', '時刻を変更'],
    '기록 삭제': ['Delete record', '記録を削除'],
    '복용': ['Dose', '服薬'],
    '사용': ['Use', '使用'],
    '완료 취소': ['Undo completion', '完了を取り消す'],
    '{count}개 모두 되돌리기': ['Undo all {count}', '{count}件すべて元に戻す'],
    '{count}개 {state}': ['{count} · {state}', '{count}件 · {state}'],
    '예정 시간 {time}': ['Scheduled for {time}', '予定時刻 {time}'],
    '{name} 시간 수정': ['Edit time for {name}', '{name}の時刻を変更'],
    '{name}님이 챙겨드렸어요': ['{name} recorded this', '{name}さんが記録しました'],
    '약을 눌러 시간을 따로 수정할 수도 있어요': ['Tap a medication to edit its time', '薬をタップして時刻を個別に変更できます'],
    '시간 한 번에 변경': ['Change all times', '時刻をまとめて変更'],
    '시간 변경': ['Change time', '時刻を変更'],
    '복용 예정 {time}': ['Scheduled for {time}', '服薬予定 {time}'],
    '매일 {times}': ['Daily at {times}', '毎日 {times}'],
    '{count}일마다 {times}': ['Every {count} days at {times}', '{count}日ごと {times}'],
    '오늘 {taken}/{total}개 완료했어요': ['Completed {taken}/{total} today', '今日は{taken}/{total}件完了しました'],
    '{time} 알림 미룸': ['Reminder postponed to {time}', '通知を{time}に延期'],
    '{hours}시간 {minutes}분 지남': ['{hours} hr {minutes} min overdue', '{hours}時間{minutes}分経過'],
    '{minutes}분 지남': ['{minutes} min overdue', '{minutes}分経過'],
    '{count}개': ['{count} medications', '{count}件'],
    '건너뜀 {actual} · 예정 {scheduled}': ['Skipped {actual} · Scheduled {scheduled}', '{actual}にスキップ · 予定 {scheduled}'],
    '소중한 의견 감사합니다': ['Thank you for your feedback', 'ご意見ありがとうございます'],
    '검토 후 반영 여부를 답변드릴게요': ['We’ll review it and reply', '確認してお返事します'],
    '직접 입력...': ['Enter a reason…', '理由を入力…'],
    '기록 변경': ['Update record', '記録を変更'],
    '{count}개 모두 건너뛰기': ['Skip all {count}', '{count}件すべてスキップ'],
    '부작용': ['Side effects', '副作用'],
    '외출 중': ['Away from home', '外出中'],
    '약 미소지': ['Medication unavailable', '薬を持っていない'],
    '의사 지시': ['Doctor’s advice', '医師の指示'],
    '컨디션 난조': ['Not feeling well', '体調不良'],
    '사유로 건너뛰기: {reason}': ['Skip: {reason}', '{reason}のためスキップ'],
    '그냥 건너뛰기': ['Skip without a reason', '理由なしでスキップ'],
    '사유 (선택)': ['Reason (optional)', '理由（任意）'],
    '사유는 복용 통계에 활용돼요': ['Reasons appear in your medication stats', '理由は服薬統計に使用します'],
    '이 약만 따로 처리해요': ['Handle this medication separately', 'この薬だけ個別に記録'],
    '같은 사유로 한꺼번에 처리해요': ['Use one reason for all selected doses', '同じ理由でまとめて記録'],
    '복용 처리를 확인해주세요': ['Check your dose status', '服薬処理を確認してください'],
    '완료 여부를 확인하지 못했어요. 연결과 계정을 확인한 뒤 다시 시도해주세요.': ['Couldn’t confirm the dose. Check your connection and account, then try again.', '服薬を確認できませんでした。接続とアカウントを確認して再試行してください。'],
    '닫기': ['Close', '閉じる'],
    '기록을 삭제할까요?': ['Delete this record?', 'この記録を削除しますか？'],
    '{name} 복용 기록을 삭제해요.': ['Delete the dose record for {name}.', '{name}の服薬記録を削除します。'],
    '복용 기록을 삭제해요.': ['Delete the dose record.', '服薬記録を削除します。'],
    '삭제하면 되돌릴 수 없어요.': ['This can’t be undone.', '削除すると元に戻せません。'],
    '아니요': ['No', 'いいえ'],
    '삭제할게요': ['Delete', '削除'],
    '약 추가': ['Add medication', '薬を追加'],
    '방금 전 {action}': ['{action} just now', 'たった今{action}'],
    '{count}분 전 {action}': ['{action} {count} min ago', '{count}分前に{action}'],
    '오늘 {time} {action}': ['{action} today at {time}', '今日{time}に{action}'],
    '어제 {time} {action}': ['{action} yesterday at {time}', '昨日{time}に{action}'],
    '{count}일 전 {action}': ['{action} {count} days ago', '{count}日前に{action}'],
    '{count}달 전 {action}': ['{action} {count} months ago', '{count}か月前に{action}'],
    '{count}년 전 {action}': ['{action} {count} years ago', '{count}年前に{action}'],
    '기록했어요': ['Recorded', '記録しました'],
    '기록에 실패했어요': ['Couldn’t save the record', '記録を保存できませんでした'],
    '시간을 변경했어요': ['Time updated', '時刻を変更しました'],
    '변경에 실패했어요': ['Couldn’t update it', '変更できませんでした'],
    '기록을 삭제했어요': ['Record deleted', '記録を削除しました'],
    '삭제에 실패했어요': ['Couldn’t delete the record', '記録を削除できませんでした'],
    '복용 완료했어요': ['Dose recorded', '服薬を記録しました'],
    '이미 처리된 약이 있어요': ['A medication was already handled', 'すでに記録した薬があります'],
    '연결이 불안정해요. 잠시 후 다시 시도해주세요': ['Connection is unstable. Try again shortly.', '接続が不安定です。少し待って再試行してください'],
    '처리 상태를 확인하지 못했어요. 다시 확인해주세요.': ['Couldn’t confirm the status. Please check again.', '処理状況を確認できませんでした。再度ご確認ください。'],
    '건너뛰기 완료': ['Skipped', 'スキップしました'],
    '이미 변경된 상태예요': ['This status has already changed', '状態はすでに変更されています'],
    '되돌리기에 실패했어요': ['Couldn’t undo', '元に戻せませんでした'],
    '복용 시각을 변경했어요': ['Dose time updated', '服薬時刻を変更しました'],
    '시간 변경에 실패했어요': ['Couldn’t change the time', '時刻を変更できませんでした'],
    '복용 기록을 바꿨어요': ['Dose record updated', '服薬記録を変更しました'],
    '기록을 바꾸지 못했어요': ['Couldn’t update the record', '記録を変更できませんでした'],
    '복용 기록을 남겼어요': ['Dose recorded', '服薬を記録しました'],
    '건너뜀 기록을 남겼어요': ['Skip recorded', 'スキップを記録しました'],
    '기록을 남기지 못했어요': ['Couldn’t save the record', '記録を保存できませんでした'],
    '건의 전송에 실패했어요. 다시 시도해주세요': ['Couldn’t send feedback. Try again.', 'ご意見を送信できませんでした。再試行してください'],
    '복용 처리 중이에요. 잠시 후 다시 시도해주세요.': ['Dose is being recorded. Try again shortly.', '服薬を記録中です。少し待って再試行してください。'],
    '서버 응답 시간이 초과됐어요. 복용 기록을 확인한 뒤 다시 시도해주세요.': ['Server timed out. Check your dose record before retrying.', 'サーバーの応答がありません。服薬記録を確認してから再試行してください。'],
    '서버에 연결하지 못했어요. 연결 상태를 확인한 뒤 다시 시도해주세요.': ['Couldn’t connect. Check your connection, then try again.', 'サーバーに接続できませんでした。接続状態を確認して再試行してください。'],
    '완료 여부를 확인하지 못했어요. 다시 시도해주세요.': ['Couldn’t confirm completion. Please try again.', '完了を確認できませんでした。再試行してください。'],
    '{count}개 모두 {cheer}': ['All {count} recorded. {cheer}', '{count}件すべて記録しました。{cheer}'],
    '{count}개 모두 저장했어요': ['All {count} saved', '{count}件すべて保存しました'],
    '{count}개 건너뛰었어요': ['Skipped {count}', '{count}件スキップしました'],
    '{count}개 모두 {time}에 다시 알려드릴게요': ['We’ll remind you about all {count} at {time}', '{count}件すべて{time}に再通知します'],
    '{count}개 약의 시각을 변경했어요': ['Updated the time for {count} medications', '{count}件の薬の時刻を変更しました'],
    '잘했어요! 오늘도 건강해지고 있어요 💪': ['Well done today! 💪', '今日もよくできました！💪'],
    '완료! 꾸준함이 최고의 약이에요 ✨': ['Done! Keep it up ✨', '完了！続けていきましょう ✨'],
    '좋아요! 오늘도 약속을 지켰어요 🎯': ['Nice work today! 🎯', '今日もよくできました！🎯'],
    '멋져요! 건강한 하루를 보내세요 🌿': ['Great job! Have a good day 🌿', 'お疲れさまです。よい一日を 🌿'],
    '완료! 작은 습관이 큰 변화를 만들어요 🌱': ['Done! Small habits add up 🌱', '完了！小さな習慣を続けましょう 🌱'],
    '최고! 당신의 건강을 응원해요 💛': ['You’ve got this! 💛', 'これからも応援しています 💛'],
    '🎉 레벨 {level}이 됐어요!': ['🎉 You reached level {level}!', '🎉 レベル{level}になりました！'],
    '{level} 도달! 최고예요{streak}': ['Reached {level}! Great job{streak}', '{level}に到達！すばらしいです{streak}'],
    ' · 연속 {count}일': [' · {count}-day streak', ' · {count}日連続'],
    '약을 챙기면 알이 생겨요': ['Record a dose to get an egg', '服薬を記録すると卵がもらえます'],
    '{level} · {current} / {total}점{streak}': ['{level} · {current}/{total} points{streak}', '{level} · {current}/{total}ポイント{streak}'],
    '\n연속 복용하면 더 많은 점수를 얻을 수 있어요!': ['\nKeep recording to earn more points!', '\n続けて記録するとポイントが増えます！'],
    '일 연속 복용': ['-day streak', '日連続で服薬'],
};

export const translationCatalog = { ...additionalTranslations, ...translations };

// Catalog-backed system key. Keep the Korean value until the rendering boundary
// translates it: constants can also be compared, stored or sent to the server.
// The release scanner requires both translations for every literal passed here.
export function translationKey(korean) { return korean; }

export function translate(language, korean, values = {}) {
    if (typeof korean !== 'string') return korean;
    const entry = translationCatalog[korean] || translationCatalog[korean.trim()];
    // QA opts in before page load; no user text or production telemetry is collected.
    if (language !== 'ko' && !entry && /[가-힣]/.test(korean) && typeof window !== 'undefined' && Array.isArray(window.__QA_TRANSLATION_MISSING)) {
        if (!window.__QA_TRANSLATION_MISSING.includes(korean)) window.__QA_TRANSLATION_MISSING.push(korean);
    }
    const padding = translationCatalog[korean] ? ['', ''] : [korean.match(/^\s*/)[0], korean.match(/\s*$/)[0]];
    const translated = language === 'ko' || !entry ? korean
        : padding[0] + entry[language === 'ja' ? 1 : 0] + padding[1];
    return translated.replace(/\{(\w+)\}/g, (placeholder, key) =>
        Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : placeholder);
}

// Server failure messages are system copy. Foreign-language diagnostics use a translated
// recovery message; arbitrary medication names, notes and chat content never use this helper.
export function localizeSystemError(message) {
    const language = readAppLanguage();
    if (typeof message !== 'string' || !message.trim() || language === 'ko') return message;
    const entry = translationCatalog[message] || translationCatalog[message.trim()];
    if (entry) return localize(message);
    const translatedEntry = Object.values(translationCatalog).find(pair => pair.includes(message) || pair.includes(message.trim()));
    if (translatedEntry) return translatedEntry[language === 'ja' ? 1 : 0];
    const japanese = /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u.test(message);
    const foreignDiagnostic = /[가-힣]/.test(message) || (language === 'ja' && !japanese && /[A-Za-z]/.test(message)) || (language === 'en' && japanese);
    return foreignDiagnostic ? localize('요청을 완료하지 못했어요. 잠시 후 다시 시도해주세요.') : message;
}

// Call only for interface copy, never medication names, notes or other user input.
export function localize(korean, values = {}) {
    return translate(readAppLanguage(), korean, values);
}

export function updateDocumentLanguage(language) {
    document.documentElement.lang = language;
    const title = translate(language, '집요한약알림');
    const description = translate(language, '집요하게 챙겨주는 약 알림');
    document.title = title;
    for (const [selector, content] of [
        ['meta[name="description"]', title],
        ['meta[property="og:title"]', title],
        ['meta[property="og:description"]', description],
    ]) document.querySelector(selector)?.setAttribute('content', content);
}

export default function useAppLanguage() {
    const [language, setLanguage] = useState(readAppLanguage);
    useEffect(() => {
        const refresh = () => setLanguage(readAppLanguage());
        window.addEventListener('languagechange', refresh);
        window.addEventListener('app-runtime-info-updated', refresh);
        window.addEventListener('pageshow', refresh);
        document.addEventListener('visibilitychange', refresh);
        updateDocumentLanguage(language);
        return () => {
            window.removeEventListener('languagechange', refresh);
            window.removeEventListener('app-runtime-info-updated', refresh);
            window.removeEventListener('pageshow', refresh);
            document.removeEventListener('visibilitychange', refresh);
        };
    }, [language]);
    return { language, t: (korean, values) => translate(language, korean, values) };
}
